// Keep a global color map (kept for future flexibility, though now same color)
const colorMap = new Map();
let colorIndex = 0;

export const initialsColumnWithColour = (value) => {
  const name = value || "N/A";
  const initials = name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase();

  // Assign index only if needed (not really used now but kept for structure)
  if (!colorMap.has(name)) {
    colorMap.set(name, colorIndex++);
  }

  const color = "var(--theme-secondary)";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "0.625rem",
        padding: "0.25rem",
        borderRadius: "7px",
        width: "fit-content",
        // border: "1px solid #A9A9A9", // dark gray border
        backgroundColor: "transparent",
      }}
    >
      {/* Avatar */}
      <div
        style={{
          width: "20px",
          height: "20px",
          borderRadius: "50%",
          backgroundColor: color, // dark gray initials background
          color: "#fff", // white initials text
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "bold",
          fontSize: "0.75rem",
          flexShrink: 0,
        }}
      >
        {initials}
      </div>

      {/* Name */}
      <span
        style={{
          fontWeight: "600",
          fontSize: "1rem",
          color: "#000", // plain black name text
        }}
      >
        {name}
      </span>
    </div>
  );
};
